<div class="search-result" [ngClass]="backgroundClass">
    <div class="result-header">
        <div class="result-type-badge order">
            <mat-icon>description</mat-icon>
            <span class="badge-label">Order</span>
        </div>
        <div class="action-buttons" (click)="$event.stopPropagation()">
            <button matMiniFab color="primary" class="d-none d-lg-block" (click)="copyButton()" matTooltip="Copy Order">
                <fa-icon icon="clipboard-list" size="lg"></fa-icon>
            </button>
            <button
                matMiniFab
                color="primary"
                class="d-none d-lg-block"
                [disabled]="true"
                (click)="customCopyButton()"
                matTooltip="Custom Copy Order">
                <fa-icon icon="copy" size="lg"></fa-icon>
            </button>
            <button
                *hideForRoles="[CustomerRoleString]"
                matMiniFab
                color="primary"
                class="d-none d-lg-block"
                [disabled]="!item().LoadID"
                (click)="loadButton()"
                matTooltip="Load Maintenance"
                [routerLink]="'dispatch/maintenance/' + item().LoadID">
                <fa-icon icon="pen" size="lg"></fa-icon>
            </button>
            <button
                *hideForRoles="[CustomerRoleString]"
                matMiniFab
                color="primary"
                class="d-none d-lg-block"
                [disabled]="!item().LoadID"
                (click)="loadTrackButton()"
                matTooltip="Load Track"
                [routerLink]="'dispatch/track/' + item().LoadID">
                <fa-icon icon="location-arrow" size="lg"></fa-icon>
            </button>
            <button
                *hideForRoles="[BrokerRoleString]"
                matMiniFab
                color="primary"
                class="d-none d-lg-block"
                [disabled]="!item().LoadID"
                (click)="loadTrackButton()"
                matTooltip="Order Track"
                [routerLink]="'customer/track/' + item().LoadNumber">
                <fa-icon icon="location-arrow" size="lg"></fa-icon>
            </button>
            <button
                matMiniFab
                color="primary"
                class="d-block d-lg-none"
                aria-label="toggle customer menu button"
                [matMenuTriggerFor]="orderMenu">
                <mat-icon class="no-margin">menu</mat-icon>
            </button>
        </div>
        @if (item().Status) {
            <div class="status-badge" [ngClass]="statusColor(item().Status)">{{ item().Status }}</div>
        }
    </div>

    <div class="result-primary">
        <div class="result-id" [highlight]="searchTerm()">{{ primaryId }}</div>
        <div class="result-meta text-muted" [highlight]="searchTerm()">{{ metaLine }}</div>
    </div>

    <div class="result-details order-details">
        <div class="detail-row">
            <div class="detail-item">
                <mat-icon class="detail-icon text-muted">people</mat-icon>
                <span class="detail-label text-muted">Customer:</span>
                <span class="detail-value" [highlight]="searchTerm()">
                    @if (item().CustomerID == 0 || item().Customer.trim() == "" || item().Customer == null) {
                        N/A
                    } @else {
                        {{ item().CustomerID }} - {{ item().Customer }}
                    }
                </span>
            </div>
        </div>

        <div class="detail-row route-row">
            <div class="detail-item">
                <mat-icon class="detail-icon text-muted">place</mat-icon>
                <div class="route-display">
                    <span class="route-from">{{ item().ShipFrom }}</span>
                    <span class="route-arrow text-muted">→</span>
                    <span class="route-to">{{ item().ShipTo }}</span>
                </div>
            </div>
        </div>

        @if (item().CustomerOrderNumber) {
            <div class="detail-row">
                <div class="detail-item">
                    <span class="detail-label text-muted">PO #:</span>
                    <span class="detail-value" [highlight]="searchTerm()">{{ item().CustomerOrderNumber }}</span>
                </div>
            </div>
        }

        <div class="detail-grid">
            @if (item().OrderReferenceIdentifiers) {
                <div class="detail-item">
                    <span class="detail-label text-muted">Order Refs:</span>
                    <mat-chip-set aria-label="Order References">
                        @for (ref of item().OrderReferenceIdentifiers.split(","); track $index) {
                            <mat-chip>
                                <span [highlight]="searchTerm()">{{ ref }}</span>
                            </mat-chip>
                        }
                    </mat-chip-set>
                </div>
            }

            @if (item().StopReferenceIdentifiers) {
                <div class="detail-item">
                    <span class="detail-label text-muted">Stop Refs:</span>
                    <mat-chip-set aria-label="All References">
                        @for (ref of item().StopReferenceIdentifiers.split(","); track $index) {
                            <mat-chip>
                                <span [highlight]="searchTerm()">{{ ref }}</span>
                            </mat-chip>
                        }
                    </mat-chip-set>
                </div>
            }
        </div>
    </div>
</div>

<mat-menu #orderMenu="matMenu" xPosition="before">
    <div class="d-flex flex-column">
        <button mat-menu-item class="d-flex align-items-center" (click)="copyButton()">
            <fa-icon class="text-primary" icon="clipboard-list" size="lg"></fa-icon>
            <span>Copy Order</span>
        </button>
        <button mat-menu-item class="d-flex align-items-center" (click)="customCopyButton()">
            <fa-icon class="text-primary" icon="copy" size="lg"></fa-icon>
            <span>Custom Copy Order</span>
        </button>
        <button
            *hideForRoles="[CustomerRoleString]"
            mat-menu-item
            class="d-flex align-items-center"
            [disabled]="!item().LoadID"
            (click)="loadButton()"
            [routerLink]="'dispatch/load/maintenance/' + item().LoadID">
            <fa-icon class="text-primary" icon="pen" size="lg"></fa-icon>
            <span>Load Maintenance</span>
        </button>
        <button
            *hideForRoles="[CustomerRoleString]"
            mat-menu-item
            class="d-flex align-items-center"
            [disabled]="!item().LoadID"
            (click)="loadTrackButton()"
            [routerLink]="'dispatch/track/' + item().LoadID">
            <fa-icon class="text-primary" icon="location-arrow" size="lg"></fa-icon>
            <span>Load Track</span>
        </button>
        <button
            *hideForRoles="[BrokerRoleString]"
            mat-menu-item
            class="d-flex align-items-center"
            [disabled]="!item().LoadID"
            (click)="loadTrackButton()"
            [routerLink]="'customer/track/' + item().LoadNumber">
            <fa-icon class="text-primary" icon="location-arrow" size="lg"></fa-icon>
            <span>Order Track</span>
        </button>
    </div>
</mat-menu>
